import React, { Component } from 'react';
import config from '../Config';

class ContactAction extends Component {
    render() {

        return (
            <div>
                <div className='b-light border-wrapper'>
                    <div className='border-card-item'>
                        <div class="p-tb-10 b-pattern">
                            <div className='t-a-c content-wrapper m-c animated-item fade-in-slide-up delay-2'>
                                <div className='b-light'>
                                    <div className='p-2 border-item'>
                                        <h4 className='uppercase ervasera c-primary'>Dai vita ai tuoi desideri di design</h4>
                                        <p className='m-t-2 c-primary'>Contattami per dare il via a un viaggio unico nella creazione del tuo ambiente</p>
                                    </div>
                                </div>
                                <a href={`mailto:${config.email}?subject=Informazioni dal sito ${config.name}`} className='d-b t-a-c m-c b-primary c-light p-1 sans-serif uppercase'>Scrivimi via E-Mail</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactAction;